<template>
    <Card class="mb-4">
      <template #header>
        <h2 class="mb-0">Vorversicherung</h2>
      </template>

      <b-row>
        <b-col md="6">
            <BaseCheckbox
          v-model="offer.softfair_vorversicherung_kuendigung_durch_vorversicherer"
          :checked="offer.softfair_vorversicherung_kuendigung_durch_vorversicherer"
          :inline="true"
        >Kündigung durch Vorversicherer</BaseCheckbox>
        </b-col>

      </b-row>

      <b-row>
        <b-col md="6">
            <BaseInput
          v-model="offer.softfair_vorversicherung_vertragsdauer_in_jahren"
          :value="offer.softfair_vorversicherung_vertragsdauer_in_jahren"
          type="number"
          label="Vertragsdauer in Jahren"
        />
        </b-col>

        <b-col md="6">
            <h4>Vorversicherung des Fahrzeuges (Referenz)</h4>
            <el-select
                v-model="offer.softfair_vorversicherung_gesellschaft_id"
                filterable
                remote
                reserve-keyword
                placeholder="Vorversicherung des Fahrzeuges (Referenz)"
                
                :loading="loading"
              >
                <el-option
                  v-for="option in insuranceList"
                  :key="option.id"
                  :label="option.bezeichnung"
                  :value="option.id"
                >
                </el-option>
              </el-select>


        </b-col>

      </b-row>

      <b-row>
        <b-col md="6">
            <BaseInput
          v-model="offer.softfair_vorversicherung_vertragsnummer"
          :value="offer.softfair_vorversicherung_vertragsnummer || ''"
          label="Vertragsnummer"
        />
        </b-col>

      </b-row>



    </Card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue';
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import Card from '@/components/Cards/Card.vue';
import { Select, Option } from "element-ui";

export default {
    name: "softfair-vorversicherung",
    components: {
        BaseInput,
        BaseCheckbox,
        BaseSelect,
        Card,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            loading: false,
            gesellschaftOptions: [
                'HUK-Coburg',
                'Allianz',
                'AXA',
                'Zurich',
                'HDI',
                'ERGO',
                'R+V',
                'VHV',
                'HUK24',
                'CosmosDirekt',
                'DEVK'
            ],
            insuranceList: []
        };
    },
    methods: {
        setDefaults() {
        },
        financial(x) {
            if (isNaN(Number.parseFloat(x).toFixed(2))) {
                return 0;
            }
            return Number.parseFloat(x).toFixed(2);
        },
        fetchInsuranceList(){
            this.$api.getSfInsuranceList().then(response => {
                console.log(response);
                this.insuranceList = response.data.insurances;
            });
        }
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
        }),
        ...mapState({
            account: state => state.account,
            offer: (state) => state.softfairOffer,
        }),
    },
    mounted() {
        this.fetchInsuranceList();
    },
};
</script>
<style></style>